import { Box, Typography, Divider, Button } from '@mui/material';
import React from 'react';

export default function NotifcationItem({
    notification,
    isNew,
    isLastItem,
    onAction,
    actionDisabled = false
}) {
    return (
        <Box
            sx={{
                animation: isNew ? 'notificationEnter 400ms ease-out' : 'none',
                '@keyframes notificationEnter': {
                    from: {
                        opacity: 0,
                        transform: 'translateY(-10px)'
                    },
                    to: {
                        opacity: 1,
                        transform: 'translateY(0)'
                    }
                }
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    gap: '10px',
                    alignItems: 'flex-start',
                    p: '15px',
                    bgcolor: notification.unread ? '#f8f8f8' : 'white',
                    transition: 'background-color 700ms ease'
                }}
            >
                {notification.avatar}

                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '5px'
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: '13px',
                            color: '#212322',
                            lineHeight: '18px'
                        }}
                    >
                        {notification.text}
                    </Typography>

                    <Typography sx={{ fontSize: '12px', color: '#8c8c8c' }}>
                        {notification.orgName
                            ? `${notification.orgName} · ${notification.time}`
                            : notification.time}
                    </Typography>

                    {notification.action && (
                        <Button
                            size="small"
                            variant="outlined"
                            disabled={actionDisabled}
                            onClick={() => onAction(notification.action)}
                            sx={{
                                alignSelf: 'flex-start',
                                mt: '2px',
                                px: '10px',
                                py: '2px',
                                minWidth: 0,
                                fontSize: '12px',
                                lineHeight: '18px',
                                textTransform: 'none',
                                borderRadius: '6px',
                                color: '#33c78f',
                                borderColor: '#33c78f',
                                '&:hover': {
                                    borderColor: '#2bb17f',
                                    bgcolor: 'rgba(51, 199, 143, 0.08)'
                                }
                            }}
                        >
                            {notification.action.label}
                        </Button>
                    )}
                </Box>

                <Box
                    sx={{
                        width: 7,
                        height: 7,
                        borderRadius: '50%',
                        bgcolor: '#33c78f',
                        flexShrink: 0,
                        mt: '4px',
                        opacity: notification.unread ? 1 : 0,
                        transform: notification.unread ? 'scale(1)' : 'scale(0.6)',
                        transition: 'opacity 700ms ease, transform 700ms ease'
                    }}
                />
            </Box>

            {isLastItem && <Divider sx={{ mx: '18px', borderColor: '#f0f0f0' }} />}
        </Box>
    );
}
